import BlockView from 'views/block/base-block-view';
import LocaleService from 'services/locale-service';
import IconLoadService from 'services/icon-load-service';
import { KeybindingService, keys } from 'services/keybinding-service';
const {
  ArrowDown,
  ArrowUp,
  ArrowLeft,
  ArrowRight,
  Enter,
  Space,
  Home,
  End,
  Escape
} = keys;

var CouseMenuView = BlockView.extend({
  className: 'new-menu-container',
  initialize: function() {
    this.model.set('current_route', []);
    this.model.set(
      'current_header',
      LocaleService.t(this.model.get('menu_header'))
    );
    IconLoadService.applyIcon('fal fa-times',this.model.cid,'fa-lg');
    this._buildMenu();
    if(this.model.get('module_key')) {
      let currentItems = this.model.get('current_items'), currentModule =[], currentActivity = [];
      const moduleKey = this.model.get('module_key');
      const menu = this.model.get('menu_items');

      currentModule = menu.find(m => m.key === moduleKey) || currentItems;
      if(currentModule && currentModule.title) {
        this.model.set('current_header', currentModule.title);
      }

      currentItems = currentModule ? currentModule.content : currentItems;
      if(currentModule && currentModule.content && this.model.get('activity_key')) {
        const activityKey = this.model.get('activity_key');
        currentActivity = currentModule.content.find(
          a => a.key === activityKey
        );

        if(currentActivity && currentActivity.title) {
          this.model.set('current_header', currentActivity.title);
        }
        
        currentItems = currentActivity ? currentActivity.content : currentItems;
        this._applyMenuItemIcons(currentItems);
      }
      this.model.set('current_items', currentItems);
    }
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function() {
    //handles click event in menu item
    this.delegate('click', 'a[role=menuitem]:not(.item-link)', event => {
      this._navigateMenu(event, 'forward');
    });
    //handles click event in backward button
    this.delegate('click', '.nav-backward', event => {
      this._navigateMenu(event, 'backward');
    });
    //handles keyboard events in menu items
    this.delegate('keydown', 'ul[role="menu"] a[role="menuitem"]', function(e) {
      const $el = $(e.currentTarget);
      const currentIndex = $el.closest('li').attr('data-index');

      if(e.defaultPrevented) {
        return; // Do nothing if the event was already processed
      }

      KeybindingService.with(e).bind(
        ArrowUp,
        () => {
          //Moves focus to the previous menu item.
          //If focus is on the first menu item, moves focus to the last menu item.
          this._setFocus(currentIndex, -1);
        },
        ArrowDown,
        () => {
          //Moves focus to the next menu item.
          //If focus is on the last menu item, moves focus to the first menu item.
          this._setFocus(currentIndex, +1);
        },
        ArrowLeft,
        () => {
          //Opens submenu and moves focus to last item in the submenu.
          this._navigateMenu(e, 'backward');
          //focus last
          // this._setFocusLast();
        },
        ArrowRight,
        () => {
          //Opens submenu and moves focus to first item in the submenu.
          //if it has submenu
          if($el.attr('aria-haspopup') === 'true') {
            this._navigateMenu(e, 'forward');
            //focus first
            // this._setFocusFirst();
          }
        },
        End,
        () => {
          //Moves focus to last item in the menubar.
          this._setFocusLast();
        },
        Home,
        () => {
          //Moves focus to first item in the menubar.
          this._setFocusFirst();
        },
        [Enter, Space],
        () => {
          //Opens submenu and moves focus to first item in the submenu.
          //Activates the menu item, which is equivalent to activating the link element from which the menu item is made.
          $el.click();
        }
      );
    });
    //handles escape event in menu
    this.delegate('keydown', `nav#${this.model.get('id')}`, function(e) {
      if(e.defaultPrevented) {
        return; // Do nothing if the event was already processed
      }
      KeybindingService.with(e).bind(Escape, () => {
        //Closes the menu.
        //Sets focus to the menu button.
        $(`#${this.model.get('id')} button.menu-close-btn`).click();
      });
    });
  },
  play: function() {
    if(this.model.get('required') === 'none') {
      this.readyToGo();
    }
  },
  _navigateMenu: function(e, direction) {
    const current_route = this.model.get('current_route');
    let current_array = this.model.get('menu_items');
    if(direction === 'forward') {
      //navigate forward
      current_route.push(
        $(e.target)
          .closest('li')
          .attr('data-index')
      );
      //update current position
      current_route.forEach((el, idx, arr) => {
        //TODO apply only to the last iteration//change this
        if(idx === arr.length - 1) {
          // debugger;
          this.model.set('current_header', current_array[el].title);
          IconLoadService.applyIcon('fal fa-chevron-left',this.model.cid);
        }
        current_array = current_array[el].content;
      });
    } else {
      //navigate backward
      current_route.pop();
      current_route.forEach((el, idx, arr) => {
        //menu header
        if(idx === arr.length - 1) {
          this.model.set('current_header', current_array[el].title);
          
        }
        current_array = current_array[el].content;
      });

      if(current_route.length == 0)
        this.model.set(
          'current_header',
          LocaleService.t(this.model.get('menu_header'))
        );
      IconLoadService.applyIcon('fal fa-times',this.model.cid,'fa-lg');

    }
    this.model.set('current_items', current_array);
    this._applyMenuItemIcons(current_array);
    this.render();
    this._setFocusLast();
  },
  _applyMenuItemIcons(current_array) {
    current_array.forEach((el,index) => {
      const icon_id = (index === 0) ? this.model.cid : `${this.model.cid}-${index}`;
      if(el.content) {
        IconLoadService.applyIcon('fas fa-caret-right',icon_id);
      } else if(el.active) {
        IconLoadService.applyIcon('fas fa-circle', icon_id, 'course-menu-icon-active course-menu-icon');
      } else if(el.completed) {
        IconLoadService.applyIcon('fas fa-check-circle', icon_id, 'course-menu-icon-completed course-menu-icon');
      } else {
        IconLoadService.applyIcon('fas fa-lock', icon_id, 'course-menu-icon-uncompleted course-menu-icon');
      }
    });
  },
  _buildModuleItem(module) {
    let module_items;
    let activities = module.activities;
    const page_key = EF.module.currentActivity.currentPage.get('key');
    const content = activities.map(activity => {
      const content = activity.get('pages').map(page => {
        return {
          key: page.get('key'),
          title: page.get('title'),
          path: `${page.get('moduleKey')}/${page.get('activityKey')}/${page.get(
            'key'
          )}`,
          active: page_key === page.get('key'),
          completed: page.get('completed'),
          status: page.get('status')
        };
      });
      return {
        key: activity.get('key'),
        title: activity.get('title'),
        path: `${activity.get('moduleKey')}/${activity.get('key')}`,
        content: content
      };
    });
    module_items = {
      title: module.get('title'),
      key: module.get('key'),
      path: module.get('key'),
      content: content
    };
    return module_items;
  },
  _buildMenu() {
    let menu = [];
    EF.modules.forEach((module, index) => {
      menu.push(this._buildModuleItem(module));
      const icon_id = (index === 0) ? this.model.cid : `${this.model.cid}-${index}`;
      IconLoadService.applyIcon('fas fa-caret-right',icon_id);
    });
    this.model.set('menu_items', menu);
    this.model.set('current_items', menu);
  },
  _setFocusFirst() {
    $(`#${this.model.get('id')} ul[role="menu"] li[data-index="0"] a`).focus();
  },
  _setFocusLast() {
    const indexLength = $(`#${this.model.get('id')} ul[role="menu"] li`).length;
    $(
      `#${this.model.get('id')} ul[role="menu"] li[data-index=${indexLength -
        1}] a`
    ).focus();
  },
  _setFocus(idx, step) {
    const indexLength = $(`#${this.model.get('id')} ul[role="menu"] li`).length;
    const newIdx = (((+idx + step) % indexLength) + indexLength) % indexLength;
    $(
      `#${this.model.get('id')} ul[role="menu"] li[data-index=${newIdx}] a`
    ).focus();
  }
});

module.exports = CouseMenuView;
